import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { cancelInput, shippingOrderInput } from "../../../inputs";
import { HttpService } from "../http.service";
import { ShippingCompanyResponse, ShippingMethodResponse, SubmitResponse } from "../../../models";
import { CompanyCreateEditInput, CompanyToggleInput } from "../../../inputs/shipping.input";
import { orderShipping } from "../../../models/admin/orders.model";

@Injectable({
    providedIn: 'root'
})
export class ShippingService extends HttpService<any | cancelInput, ShippingCompanyResponse> {

    private shippingCompanyListSubject = new BehaviorSubject<ShippingCompanyResponse | null>(null);
    readonly shippingCompanyList$ = this.shippingCompanyListSubject.asObservable();

    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'shipping');
    }

    getShippingFee(ShippingInput: any): Observable<SubmitResponse> {
        return this.create(ShippingInput, `calculate-fee`).pipe(catchError((error) => of(error)));
    }

    getShippingCompanies(page = 1, limit = 10): Observable<ShippingCompanyResponse | null> {
        return this.getPagedGeneral('shipping/company', page, limit).pipe(
            tap(response => this.shippingCompanyListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredShippingCompanies(entity: any): Observable<ShippingCompanyResponse | null> {
        return this.filterAllActionPaged(entity, 'company').pipe(
            tap((response) => this.shippingCompanyListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    deleteShippingById(shippingId: string): Observable<SubmitResponse> {
        return this.delete(shippingId, 'company');
    }
    createShippingCompany(companyInput: CompanyCreateEditInput): Observable<SubmitResponse> {
        return this.create(companyInput, 'company').pipe(catchError((error) => of(error)));
    }
    editShippingCompany(companyInput: CompanyCreateEditInput): Observable<SubmitResponse> {
        return this.update(companyInput, 'company').pipe(catchError((error) => of(error)));
    }
    toggleShippingCompany(companyInput: CompanyToggleInput): Observable<SubmitResponse> {
        return this.update(companyInput, 'company/enable').pipe(catchError((error) => of(error)));
    }
    createShippingOrder(OrderShippingInput: shippingOrderInput): Observable<SubmitResponse> {
        return this.create(OrderShippingInput, '/company/assign-to-order').pipe(catchError((error) => of(error)));
    }
    deleteShippingCompanyFromOrderById(orderId: string): Observable<SubmitResponse> {
        return this.deleteDirectUrl(orderId, 'delivery');
    }
    getShippingLabel(orderId: string): Observable<orderShipping> {
        return this.getById(orderId, 'label/order').pipe(catchError((error) => of(error)));
    }

    getShippingLabelByOrderId(orderId: string): Observable<orderShipping> {
        return this.getById(orderId, 'label/order').pipe(catchError((error) => of(error)));
    }

}